module.exports = __webpack_public_path__ + "assets/img/sailing-version-advantage-icon.256ba442.png";